<div class="bulk-content-container tw-max-w-6xl tw-mx-auto tw-p-6">
  <!-- Header Section -->
  <div class="tw-text-center tw-mb-8">
    <h1 class="tw-text-3xl tw-font-bold tw-text-white tw-mb-4">Bulk Data Access Options</h1>
    <p class="tw-text-lg tw-text-gray-300 tw-max-w-3xl tw-mx-auto">
      Choose from our comprehensive suite of bulk data access methods to integrate people
      intelligence into your workflows. Each option is designed to meet different use cases and
      technical requirements.
    </p>
  </div>

  <!-- Options Grid -->
  <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6">
    <mat-card
      *ngFor="let option of bulkOptions; let i = index"
      class="bulk-option-card tw-transition-all tw-duration-300 hover:tw-border-teal-500 hover:tw-shadow-lg">
      <!-- Card Header - Always Visible -->
      <mat-card-header
        class="tw-cursor-pointer tw-transition-colors tw-duration-200 hover:tw-bg-gray-750">
        <div class="tw-flex tw-items-start tw-gap-4 tw-w-full">
          <!-- Icon -->
          <div
            class="tw-flex-shrink-0 tw-w-12 tw-h-12 tw-bg-teal-500/20 tw-rounded-lg tw-flex tw-items-center tw-justify-center">
            <mat-icon
              class="tw-text-2xl tw-text-teal-400 tw-h-auto tw-w-auto"
              >{{ option.icon }}</mat-icon
            >
          </div>

          <!-- Content -->
          <div class="tw-flex-1 tw-min-w-0">
            <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
              <mat-card-title class="tw-text-xl tw-font-semibold tw-text-white">
                {{ option.title }}
              </mat-card-title>
            </div>
            <mat-card-subtitle class="tw-text-gray-300 tw-leading-relaxed">
              {{ option.description }}
            </mat-card-subtitle>
          </div>
        </div>
      </mat-card-header>

      <mat-card-content
        class="tw-overflow-hidden tw-transition-all tw-duration-300 tw-max-h-[600px]">
        <div class="tw-border-t tw-border-gray-700 tw-pt-6">
          <!-- Stats Grid -->
          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-4 tw-mb-6">
            <mat-card *ngFor="let stat of option.stats" class="tw-bg-gray-900/50">
              <mat-card-content class="tw-p-4">
                <div class="tw-flex tw-items-center tw-gap-3">
                  <mat-icon
                    *ngIf="stat.icon"
                    class="tw-text-teal-400 tw-text-xl"
                    >{{ stat.icon }}</mat-icon
                  >
                  <div class="tw-flex-1">
                    <div class="tw-text-2xl tw-font-bold tw-text-teal-400 tw-mb-1">
                      {{ stat.value }}
                    </div>
                    <div class="tw-text-xs tw-text-gray-400 tw-uppercase tw-tracking-wide">
                      {{ stat.label }}
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Detailed Description -->
          <div class="tw-mb-6">
            <p class="tw-text-gray-300 tw-leading-relaxed">
              {{ option.detailedDescription }}
            </p>
          </div>

          <!-- Action Buttons -->
          <mat-card-actions class="tw-flex tw-gap-3 tw-flex-wrap">
            <!-- Get Started Link Button -->
            <a *ngIf="option.getStartedLink" [routerLink]="option.getStartedLink">
              <button mat-raised-button color="primary" class="tw-bg-teal-500 hover:tw-bg-teal-600">
                <mat-icon class="tw-mr-2">launch</mat-icon>
                Get Started
              </button>
            </a>

            <!-- Contact Us to Get Started Button -->
            <button
              *ngIf="option.intercomMessage"
              mat-raised-button
              color="primary"
              class="tw-bg-teal-500 hover:tw-bg-teal-600"
              (click)="handleGetStarted(option)">
              <mat-icon class="tw-mr-2">chat</mat-icon>
              Contact Us to Get Started
            </button>

            <a *ngIf="option.documentationLink" [href]="option.documentationLink" target="_blank">
              <button
                mat-stroked-button
                class="tw-border-gray-600 tw-text-gray-300 hover:tw-bg-gray-700">
                <mat-icon class="tw-mr-2">description</mat-icon>
                Documentation
              </button>
            </a>
          </mat-card-actions>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Bottom CTA Section -->
  <mat-card class="tw-mt-12 tw-text-center tw-bg-gray-800/50">
    <mat-card-header class="tw-flex tw-justify-center">
      <mat-card-title class="tw-text-2xl tw-font-semibold tw-text-white tw-mb-4"
        >Need Help Choosing?</mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <p class="tw-text-gray-300 tw-mb-6 tw-max-w-2xl tw-mx-auto">
        Our team can help you determine the best data access method for your specific use case.
        Schedule a consultation to discuss your requirements.
      </p>
    </mat-card-content>
    <mat-card-actions class="tw-flex tw-gap-4 tw-justify-center tw-flex-wrap">
      <button
        mat-raised-button
        color="primary"
        class="tw-bg-teal-500 hover:tw-bg-teal-600"
        (click)="scheduleConsultation()">
        <mat-icon class="tw-mr-2">calendar_today</mat-icon>
        Schedule Consultation
      </button>
    </mat-card-actions>
  </mat-card>
</div>
